import { DatePipe, NumberSymbol } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MdbTableDirective, ModalDirective } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { Clientes } from '../cliente';

import { ClienteService } from '../cliente.service';
import { Comprobante } from '../comprobante';
import { ComprobanteService } from '../comprobante.service';
import { ImpuestoService } from '../impuesto.service';
import { ImpuestoValor } from '../impuestoValor';
import { ProveedorService } from '../proveedor.service';
import { Retencion } from '../retencion';
import { RetencionComprasService } from '../retencion-compras.service';
import { RetencionDetalle } from '../retencionDetalle';
import { validarCedula } from '../validar-cedula';
import { validarRuc } from '../validar-ruc';

@Component({
  selector: 'app-retencion-compras',
  templateUrl: './retencion-compras.component.html',
  styleUrls: ['./retencion-compras.component.css']
})
export class RetencionComprasComponent implements OnInit {

  numeroRetencion:string;
  numeroDocumento:string;
  clienteActual: Clientes;
  fechaContable:string;
  baseIva:number
  impuesto:string
  baseImponible:number
  descripcion:string
  porcentajeRetencion:number
  fechaEmision:Date
  clienteNuevo: Clientes ;
  listCliene: Clientes[];
  codigoImpuesto:string;
  listadoImpuestoValor:ImpuestoValor[]
  editForm: FormGroup;
  comprobante:Comprobante[];
  obligado:string
  validaIdentificacion:boolean
  listaClientesActulizar: Clientes[] = [];
  listaRetencionDetalle:RetencionDetalle[]=[];
  retencionDet:RetencionDetalle
  retencion:Retencion;
  @ViewChild("processingModal") public mdbModal: ModalDirective;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;
  identificacion: string;
  
  constructor(
    private api: ProveedorService,
    private apiRetencion: RetencionComprasService,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private alertService: AlertService,
    private apiImpuesto: ImpuestoService,
    private apiCompobante:ComprobanteService
  ) { }


  agregarCliente() {
    this.editForm = this.formBuilder.group({
      nombrerazonsocial: ["", Validators.required],
      numeroidentificacion: ["", Validators.required],
      direccion: ["", Validators.required],
      telefonoconvencional: ["", Validators.required],
      celular: ["", Validators.required],
      correo: ["", Validators.required],
      tipoCliente: ["", Validators.required],
      codcliente: [0, Validators.required],
      tipoidentificacion: ["", Validators.required],
      producto: ["", Validators.required],
    });

    this.mdbModal.show();
  }

  onChangeFecha(newObj) {
    this.fechaContable=this.datePipe.transform(newObj, 'MM/yyyy');
    
      }

  ngOnInit(): void {
    this.editForm = this.formBuilder.group({
      nombrerazonsocial: ["", Validators.required],
      numeroidentificacion: ["", Validators.required],
      direccion: ["", Validators.required],
      telefonoconvencional: ["", Validators.required],
      celular: ["", Validators.required],
      correo: ["", Validators.required],
      tipoCliente: ["", Validators.required],
      codcliente: [0, Validators.required],
      tipoidentificacion: ["", Validators.required],
      //codigoProducto: ["", Validators.required],
      producto: ["", Validators.required],
    });
    this.obtenerSecuenciaComprobante();
    this.listarProveedor();
  }
  obtenerSecuenciaComprobante(){
  this.apiCompobante.secuenciaComprobante(localStorage.getItem('id'),'S')
  .subscribe((
    data:Comprobante[]) => {
    this.comprobante = data;
    this.comprobante.forEach(element => {
      this.numeroRetencion=this.PadLeft(element.secuencial,9);
     
    });
    });
  }
 

  guardarRetencion(){
    this.retencion= new Retencion;
    this.retencion.id=0;
    this.retencion.fecha=this.fechaEmision;
    this.retencion.mesContable=Number.parseInt(this.datePipe.transform(this.fechaEmision, 'mm'));
    this.retencion.anioContable=Number.parseInt(this.datePipe.transform(this.fechaEmision, 'yyyy'));
    this.retencion.numeroComprobante=this.numeroDocumento
    this.retencion.numeroRetencion=this.numeroRetencion
    this.retencion.idCliente=this.clienteActual.codcliente
    this.retencion.idEmisor=Number.parseInt(localStorage.getItem('id'))
    this.retencion.establecimiento=(localStorage.getItem('establecimiento'));
    this.retencion.usuario=(localStorage.getItem('usuario'));
    this.retencion.detalle=this.listaRetencionDetalle
    this.apiRetencion.setActulizarRetencion(this.retencion).subscribe(
      ( data: Retencion)=> {
      
      this.alertService.info('Se guardo la factura...');
      this.liminar();
      this.ngOnInit();
       },
          error  => {
      
        this.alertService.warning(error);
      
      }
      
      );
  
  }

    PadLeft(value, length) {
      return (value.toString().length < length) ? this.PadLeft("0" + value, length) : 
      value;
    }
  onChange1($event: Event) {
    this.editForm.controls.numeroidentificacion.setValue($event);
    this.buscarCedula();
}

liminar(){
this.listaRetencionDetalle=[]
this.baseIva=0.0;
this.baseImponible=0.0



}
actulizarDatosCliente() {
  this.clienteActual.enviado="S";
  this.clienteActual.obligadoLlevarContabilidad=this.obligado
  this.listaClientesActulizar[0] = this.clienteActual;
  this.identificacion=this.clienteActual.numeroidentificacion.toString()
  if (this.identificacion.length<=10){
    if (validarCedula(this.identificacion)){
      this.validaIdentificacion=true;
    }

  }
  if (this.identificacion.length>10){
    if (validarRuc(this.identificacion)){
      this.validaIdentificacion=true;
    }

  }   
 if (this.validaIdentificacion==true){
 
  this.api.setActulizarCliente(this.listaClientesActulizar).subscribe(

    data  => {
      this.alertService.success("Se agrego un nuevo cliente");
      this.mdbModal.hide();
      this.listarProveedor();               
    
    },
    
    error  => {
    
   this.alertService.danger(error)
    
    }
    
    );
  }else{
    this.alertService.success("Verificar Ruc o Cedula");
    
  }
}
onChangeValor(newValue){
this.listadoImpuestoValor.forEach(element => {
  if (element.codigo===newValue)
{
this.descripcion=element.descripcion
  this.codigoImpuesto=newValue;
  if (this.impuesto==='1'){
    this.porcentajeRetencion=element.porcentaje
  }else{
    this.porcentajeRetencion=element.porcentajeRetencion
  }

}});
}
onChangeImpuesto(newValue) {
  if (newValue=='2'){
    this.impuesto='2';
  }else{
    this.impuesto='1';
  }
  this.listarImpuestos(this.impuesto)
}



onChangeObligado(newValue) {
  this.obligado=newValue
}

agregarRetencion(){
  this.retencionDet= new RetencionDetalle()
  this.retencionDet.porcentaje=this.porcentajeRetencion
  this.retencionDet.codigo=this.impuesto;
  if (this.impuesto==='2'){
  this.retencionDet.base=this.baseIva
  }else{
    this.retencionDet.base=this.baseImponible
  }
  this.retencionDet.codigoImpuesto=this.codigoImpuesto
  this.retencionDet.total=(this.retencionDet.base*this.retencionDet.porcentaje)/100
  this.retencionDet.descripcion=this.descripcion
  this.retencionDet.fechaEmision=this.fechaEmision
  this.listaRetencionDetalle.push(this.retencionDet);
  this.mdbTable.setDataSource(this.listaRetencionDetalle);
  this.mdbTable.dataSourceChange(); 
  
}


eliminar(numero: number) {
  //this.removeAllElements( this.listaProductos,numero);

  this.listaRetencionDetalle.forEach((value,index)=>{
    if(value.orden==numero)  this.listaRetencionDetalle.splice(index,1);
});

  //this.listaProductos.splice(numero,1);
 
  this.mdbTable.setDataSource(this.listaRetencionDetalle);
  this.mdbTable.dataSourceChange();
     
}


actulizarCliente() {
  this.clienteNuevo = new Clientes();
  this.clienteNuevo.nombrerazonsocial = this.editForm.controls.nombrerazonsocial.value;
  this.clienteNuevo.numeroidentificacion = this.editForm.controls.numeroidentificacion.value;
  this.clienteNuevo.direccion = this.editForm.controls.direccion.value;
  this.clienteNuevo.telefonoconvencional = this.editForm.controls.telefonoconvencional.value;
  this.clienteNuevo.celular = this.editForm.controls.celular.value;
  this.clienteNuevo.tipoCliente = this.editForm.controls.tipoCliente.value;
  this.clienteNuevo.codcliente = this.editForm.controls.codcliente.value;
  this.clienteNuevo.correo = this.editForm.controls.correo.value;
  this.clienteNuevo.tipoidentificacion = 'P';
  this.clienteNuevo.idEmisor = Number(localStorage.getItem("id"));
  this.clienteNuevo.enviado = 'S';
  this.listaClientesActulizar[0] = this.clienteNuevo;
  this.identificacion=this.clienteNuevo.numeroidentificacion.toString()
  if (this.identificacion.length<=10){
    if (validarCedula(this.identificacion)){
      this.validaIdentificacion=true;
    }

  }
  if (this.identificacion.length>10){
    if (validarRuc(this.identificacion)){
      this.validaIdentificacion=true;
    }

  }   
 if (this.validaIdentificacion==true){
 
  this.api.setActulizarCliente(this.listaClientesActulizar).subscribe(

    data  => {
      this.alertService.success("Se agrego un nuevo cliente");
      this.mdbModal.hide();
      this.listarProveedor();
    
    },
    
    error  => {
    
   this.alertService.danger(error)
    
    }
    
    );

  }else{
    this.alertService.danger("Verifique Ruc o Cedula");
  
  }

}

buscarCedula() {
  console.log(this.editForm.controls.numeroidentificacion.value);
  if (this.editForm.controls.numeroidentificacion.value!=null){
  this.api
    .getCliente(
      this.editForm.controls.numeroidentificacion.value,)
    
    .subscribe(
      (data: Clientes[]) => {
        data.forEach((item) => {
          this.clienteActual = item;
          if (this.clienteActual == null) {
            this.alertService.danger("No existe la cédula o Ruc");
            this.editForm.controls.numeroidentificacion.setValue("");
          } else {
            this.editForm.controls.direccion.setValue(
              this.clienteActual.direccion
            );
            this.editForm.controls.nombrerazonsocial.setValue(
              this.clienteActual.nombrerazonsocial
            );
            this.editForm.controls.numeroidentificacion.setValue(
              this.clienteActual.numeroidentificacion
            );
            this.editForm.controls.correo.setValue(this.clienteActual.correo);
            console.log(this.editForm.controls.correo.value);
          
          }
        });
        console.log(this.clienteActual);
      },
      (err) => {
        this.alertService.danger("Problemas con la conexión");
      }
    );
  }
}
  listarProveedor()
  {
   this.api
   .getClientes(
     localStorage.getItem("id")
   )
   .subscribe(
     (data: Clientes[]) => {
         this.listCliene=data;
         console.log(this.listCliene);
       });
     }



listarImpuestos(codigo)
{
 this.apiImpuesto
 .getImpuestosCodigo(codigo,
   localStorage.getItem("id")
 )
 .subscribe(
   (data: ImpuestoValor[]) => {
       this.listadoImpuestoValor=data;
     
     });
   }

}

